import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Flex, Spinner } from "@chakra-ui/react";
import { AuthContext } from "../context/AuthContext";
import { featureRoutes } from "../constants/featureCostants";

// Guards a route group behind one or more feature ids. `Navbar` only hides
// nav links for disabled features - this is what actually stops a logged-in
// user from reaching a page by typing the URL directly.
const FeatureRoute = ({ featureIds }) => {
    const { currLocation, features, featuresLoading } = useContext(AuthContext);

    if (!currLocation) {
        return <Navigate to="/choose-location" replace />;
    }

    if (featuresLoading) {
        return (
            <Flex justify="center" align="center" minH="100vh">
                <Spinner size="xl" color="brand.700" />
            </Flex>
        );
    }

    const allowed = featureIds.some((id) => features.includes(id));

    if (!allowed) {
        const fallback = featureRoutes.find((route) => features.includes(route.id));
        return <Navigate to={fallback ? fallback.link : "/no-access"} replace />;
    }

    return <Outlet />;
};

export default FeatureRoute;
